import { rei } from "@/services/api"

class RelatorioCustaService {
  static getPdfRelatorio (busca) {
    return rei.post(`relatorio-custas`, busca, { responseType: 'arraybuffer' }).then((res) => {
      let blob = new Blob([res.data], { type: 'application/pdf' })
      let url = window.URL.createObjectURL(blob)

      return url
    })
  }

  static getItensRelatorio (busca) {
    return rei.post(`listagem-relatorio-custas`, busca).then(res => res.data)
  }

  static exportExcelRelatorio (busca) {
    return rei.post(`export/relatorio-custas`, busca, {
      responseType: 'arraybuffer'
    }).then((res) => {
      return res
    })
  }
}

export default RelatorioCustaService
